import {
    AUTHORIZE_USER,
    AUTHORIZE_USER_FAILURE,
    AUTHORIZE_USER_SUCCESS,
    SCOPE_DETAILS,
    SCOPE_DETAILS_FAILURE,
    SCOPE_DETAILS_SUCCESS,
    VALIDATE_URL,
    VALIDATE_URL_FAILURE,
    VALIDATE_URL_SUCCESS,
} from '../actions/actionTypes/oauth-types';

const initialState = {
    isLoading: true,
    isErrored: false,
    clientId: null,
    isValidRequest: false,
    thirdPartyUserId: null,
    thirdPartyName: null,
    user: null,
    redirectUri: null,
    responseType: null,
    approvalPrompt: null,
    returnCode: null,
    errorLabel: null,
    description: null,
    scope: null,
    scopeDetails: null,
    urlState: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case VALIDATE_URL:
            return {
                ...state,
                user: null,
                isLoading: true,
                clientId: action.payload.client_id,
                isValidRequest: false,
                thirdPartyUserId: action.payload.third_party_user_id,
                redirectUri: action.payload.redirect_uri,
                responseType: action.payload.response_type,
                approvalPrompt: action.payload.approval_prompt,
                scope: action.payload.scope,
                urlState: action.payload.state,
            };
        case VALIDATE_URL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isErrored: false,
                isValidRequest: true,
            };
        case VALIDATE_URL_FAILURE:
            return {
                ...state,
                isLoading: false,
                isErrored: true,
                isValidRequest: false,
                returnCode: action.payload.ReturnCode,
                description: action.payload.Description ?? null,
                errorLabel: action.payload.ErrorLabel ?? null,
            };
        case SCOPE_DETAILS:
        case AUTHORIZE_USER:
            return {
                ...state,
            };
        case SCOPE_DETAILS_SUCCESS:
            return {
                ...state,
                thirdPartyName: action.payload.thirdPartyName,
                scopeDetails: action.payload.scopeDetails,
                isLoading: false,
                isErrored: false,
            };
        case SCOPE_DETAILS_FAILURE:
        case AUTHORIZE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                isErrored: true,
                returnCode: action.payload.ReturnCode,
                description: action.payload.Description ?? null,
                errorLabel: action.payload.ErrorLabel ?? null,
            };
        case AUTHORIZE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isErrored: false,
            };
        default:
            return state;
    }
}

export default app;
